(function EmailParser($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('main/emailParser', function onload()
		{
			$('#ep-select').on('change', function click(e) {
				$('#ep-message').prop('src', Adzuki.base_uri + '/main/emailParserMessage/' + encodeURIComponent($(this).val()));
				$('#ep-debug').prop('src', Adzuki.base_uri + '/main/emailParserDebug/' + encodeURIComponent($(this).val()));
			});
		});
	});

}(jQuery, window.Adzuki || {}));
